<template>
	<div class="main">
		<hwk-header type="orderList"></hwk-header>
		<div class="warp order-list">
			<hwk-left type="orderList"></hwk-left>
			<div class="o-l-r">
				<div class="top-nav flex">
					<div class="item" :class="{on:navindex==index}" v-for="(item,index) in navlist" :key="index"
						@click="changeNav(index)">{{item}}</div>
				</div>
				<div class="filter" v-if="filterShow">
					<el-form ref="form" :model="form" label-width="80px" label-position="right">
						<table class="table-form">
							<tr>
								<td>
									<el-form-item label="系统订单">
										<el-input v-model="form.order_number" placeholder="请输入系统订单编号"
											clearable></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="店铺订单">
										<el-input v-model="form.other_order_number" placeholder="请输入店铺订单编号"
											clearable></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="发货单号">
										<el-input v-model="form.logistics_number" placeholder="请输入发货单号"
											clearable></el-input>
									</el-form-item>
								</td>
							</tr>
							<tr>
								<td>
									<el-form-item label="下单日期">
										<el-date-picker v-model="form.times" style="width: 100%;" type="daterange"
											clearable range-separator="至" start-placeholder="开始日期" format="yyyy-MM-dd"
											value-format="yyyy-MM-dd" end-placeholder="结束日期">
										</el-date-picker>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="出售平台">
										<el-input v-model="form.source_string" placeholder="请输入" clearable></el-input>
										<!-- <el-select v-model="form.address_source_id" placeholder="选择订单来源" style="width: 100%;"
											@change="sourceChange">
											<el-option :label="item.name" :value="item.id" v-for="(item,index) in slist"
												:key="index"></el-option>
										
										</el-select> -->
									</el-form-item>
								</td>
								<td>
									<el-form-item label="出售店铺">
										<el-input v-model="form.user_shop_string" placeholder="请输入"
											clearable></el-input>
									</el-form-item>
								</td>
							</tr>
							<tr>
								<td>
									<el-form-item label="发货仓库">
										<el-select v-model="form.warehouse_id" clearable placeholder="全部"
											style="width: 100%;">
											<el-option :label="item.name" :value="item.id" v-for="(item,index) in wlist"
												:key="index"></el-option>

										</el-select>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="收货人">
										<el-input v-model="form.name" placeholder="请输入" clearable></el-input>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="支付方式">
										<!-- 1=授信结算2=支付宝,3=微信,4=银联支付 -->
										<el-select v-model="form.pay_type" placeholder="全部" style="width: 100%;"
											clearable>
											<el-option label="支付宝" value="2"></el-option>
											<el-option label="微信" value="3"></el-option>
											<el-option label="银联支付" value="4"></el-option>
											<el-option label="授信结算" value="1"></el-option>
										</el-select>
									</el-form-item>
								</td>
							</tr>
							<tr>
								<td>
									<el-form-item label="签名">
										<el-select v-model="form.is_sign" placeholder="全部" style="width: 100%;"
											clearable>
											<el-option label="是" value="1"></el-option>
											<el-option label="否" value="2"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>
									<el-form-item label="订单类型">
										<el-select v-model="form.is_new" placeholder="全部" style="width: 100%;"
											clearable>
											<el-option label="新订单" value="1"></el-option>
											<el-option label="老订单" value="2"></el-option>
										</el-select>
									</el-form-item>
								</td>
								<td>
									<div class="footer-btn">
										<div class="btn1 pointer" @click="reset">取 消</div>
										<div class="btn2 pointer" @click="submit">保 存</div>
									</div>
								</td>
							</tr>
						</table>
					</el-form>
				</div>
				<div class="search flex">
					<div class="sl">共查询到 <span>{{total}}</span>个订单</div>
					<div class="sr flex">
						<div class="s1"><el-input placeholder="请输入收货人姓名/订单编号/发货单号" @change="search" v-model="keyword"
								clearable>
								<i slot="suffix" class="el-input__icon el-icon-search"></i>
							</el-input></div>
						<div class="s2 pointer" @click="filterShow=!filterShow">
							<img src="@/assets/filter.png" alt="" /><span>筛选</span>
						</div>
						<div class="s2 pointer" @click="exportOrder"><img src="@/assets/file.png"
								alt="" /><span>导出</span></div>
					</div>
				</div>
				<div class="hwk-order-list">
					<div class="t flex">
						<div class="i i1" @click="changeAll">
							<img src="@/assets/f2.png" alt="" v-if="checked" />
							<img src="@/assets/f1.png" alt="" v-else />
						</div>
						<div class="i i2">商品</div>
						<div class="i i3">价格</div>
						<div class="i i3">支付方式</div>
						<div class="i i3">订单金额</div>
						<div class="i i3">订单类型</div>
						<div class="i i3">订单操作</div>
					</div>
					<div class="item" v-for="(item,index) in list" :key="index">
						<div class="i-top flex">
							<div class="i i1" @click="changeChecked(item,index)">
								<img src="@/assets/f2.png" alt="" v-if="item.checked" />
								<img src="@/assets/f1.png" alt="" v-else />
							</div>
							<div class="i i2">
								{{$timeFormat(item.updatetime,'yyyy-mm-dd')||$timeFormat(item.createtime,'yyyy-mm-dd')}}
							</div>
							<div class="i i3 flex">
								<div class="ord">系统订单：{{item.order_number}}</div>
								<div class="ref flex" v-if="item.order_refund.length>0">
									<div class="ii" v-for="(item2,index2) in item.order_refund" :key="index2"
										@click="pageToAfterOrder(item2.id,item.order_number)">
										<span>售后订单</span><i class="el-icon-arrow-right"></i>
									</div>
								</div>

							</div>
							<!-- 状态:10=待支付,15=待审核,20=代发货,30=已发货(待收货),40=已收货,50=已完成,60=交易关闭	 -->
							<div class="i i4 on" v-if="item.status == 10">待支付</div>
							<div class="i i4" v-if="item.status == 15">待审核</div>
							<div class="i i4" v-if="item.status == 20">待发货</div>
							<div class="i i4" v-if="item.status == 30">已发货</div>
							<div class="i i4" v-if="item.status == 40">已收货</div>
							<div class="i i4" v-if="item.status == 50">已完成</div>
							<div class="i i4" v-if="item.status == 60">交易关闭</div>
						</div>
						<div class="i-middle flex">
							<div class="i1">
								<div class="ii flex" v-for="(item2,index2) in item.order_goods" :key="index2">
									<div class="iil flex">
										<img :src="http + item2.goods_image" alt="" />
										<div class="con">
											<div class="name">{{item2.goods_title}}</div>
											<div class="p">{{item.warehouse_string}}</div>
											<div class="p">{{item2.goods_child_sku_string}}</div>
										</div>
									</div>
									<div class="iir">
										<p>￥{{item2.price}}</p>
										<p>x{{item2.number}}</p>
									</div>
								</div>
							</div>
							<div class="i2">
								<p v-if="item.pay_type == 0">-</p>
								<p v-if="item.pay_type == 1">授信结算</p>
								<p v-if="item.pay_type == 2">支付宝</p>
								<p v-if="item.pay_type == 3">微信</p>
								<p v-if="item.pay_type == 4">银联支付</p>
							</div>
							<div class="i3">
								<p>￥{{item.pay_price}}</p>
								<p
									v-if="item.order_address.logistics_price && item.order_address.logistics_price !== '0.00'">
									<span>运费:￥{{item.order_address.logistics_price}}</span>
								</p>
								<p v-if="item.sign_price && item.sign_price !== '0.00'">
									<span>签名:￥{{item.sign_price}}</span>
								</p>
							</div>
							<div class="i4">
								<p>{{item.is_new==1?'新订单':'老订单'}}</p>
							</div>

							<div class="i5">
								<p v-if="item.status == 10" @click="pay(item.id)"> 支付</p>
								<p><span @click="toDetails(item.id)">详情</span><span v-if="item.status == 10"
										@click="cancelOrder(item.id)">取消</span>
								</p>
								<p v-if="item.status == 10||item.status == 15||item.status == 20"
									@click="changeAddr(item.id)">修改地址</p>
							</div>
						</div>
						<div class="i-bottom">
							<p><span>收货人：{{item.order_address.name}}</span><span>收货地：{{item.order_address.country}}</span><span>出售店铺：{{item.order_address.user_shop_string}}</span><span>订单编号：{{item.order_address.other_order_number}}</span>
							</p>
							<div class="sh flex" v-if="item.order_address.status == 1">
								<img src="@/assets/w.png" /><span>地址审核中</span>
							</div>
						</div>
						<!-- 状态:10=待支付,15=待审核,20=代发货,30=已发货(待收货),40=已收货,50=已完成,60=交易关闭	 -->
						<div class="i-bottom2" v-if="item.order_address.status == 3">
							<div class="con">
								<img src="@/assets/warning.png"
									alt="warning" /><span>驳回原因：{{item.order_address.reject_message}}</span>
							</div>

						</div>
					</div>
				</div>
				<div class="pagination">
					<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
						:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<navigation :usershow='false'></navigation>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import hwkLeft from './hwk-left.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation,
			hwkLeft
		},
		data() {
			return {
				keyword: "",
				filterShow: false,
				leftType: 'orderList',
				form: {
					warehouse_id: "",
					pay_type: "",
					is_new: "",
					is_sign: "",
					order_number: "",
					other_order_number: "",
					logistics_number: "",
					source_string: "",
					user_shop_string: "",
					name: "",
					times: [],
				},
				navlist: ['全部订单', '待支付', '待审核', '待发货', '已发货', '已收货', '已完成', '交易关闭'],
				statusList: ['', 10, 15, 20, 30, 40, 50,
					60
				], //<!-- 状态:10=待支付,15=待审核,20=代发货,30=已发货(待收货),40=已收货,50=已完成,60=交易关闭	 -->
				navindex: 0,
				show1: false,
				show2: false,
				list: [],
				pageSize: 10,
				input3: "",
				checked: false,
				currentPage: 1,
				total: 0,
				status: '',
				http: this.$imgUrl,
				http2: this.$imgWebUrl,
				slist: [],
				wlist: []

			};
		},
		created() {
			if (this.$route.query.status) {
				this.status = this.$route.query.status
				this.navindex = this.statusList.findIndex(item => item == this.status)
			}

			if (this.$route.query.times) {
				this.form.times = this.$route.query.times.split(',')
			}


			this.getslist()
			this.getlist();
			this.getnavlist()
		},

		methods: {
			changeChecked(item, index) {
				item.checked = !item.checked
				this.checked = this.list.every(item => item.checked)
				this.$forceUpdate()
			},
			changeAll() {
				this.checked = !this.checked
				this.list.forEach(item => item.checked = this.checked)
			},
			search() {
				this.getlist();
			},
			submit() {
				this.getlist();
			},
			reset() {
				this.form = {
					warehouse_id: "",
					pay_type: "",
					is_new: "",
					is_sign: "",
					order_number: "",
					other_order_number: "",
					logistics_number: "",
					source_string: "",
					user_shop_string: "",
					name: "",
					times: [],
				}
				this.getlist();
			},
			getnavlist() {
				this.$http.get('/api/goods/goods_option', {

				}).then(res => {
					this.wlist = res.data.warehouse_data

				});
			},

			getslist() {
				this.$http.get('/api/user_shop/source_list', {

				}).then(res => {
					console.log(res)
					this.slist = res.data

				});
			},
			cancelOrder(id) {
				this.$confirm('此操作将取消此订单, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					this.$http.post('/api/order/cancel', {
						order_id: id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '取消成功!'
						});
						this.getlist();
					});

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},

			handleCurrentChange(val) {
				console.log(`当前页: ${val}`, this.currentPage);
				this.currentPage = val
				this.getlist();
			},
			changeNav(index) {
				if (this.navindex != index) {
					this.navindex = index
					this.status = this.statusList[this.navindex]
					this.getlist();

				}
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},

			pageToAfterOrder(id, num) {
				// this.$router.push({
				// 	path: "/afterSalesDetails",
				// 	query: {
				// 		id: id,

				// 	}
				// });

				this.$router.push({
					path: "/afterSalesList",
					query: {
						orderNum: num,

					}
				});
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/orderDetails",
					query: {
						id: id,
						operate: 'details'
					}
				});
			},
			changeAddr(id) {
				this.$router.push({
					path: "/orderDetails",
					query: {
						id: id,
						operate: 'address'
					}
				});
			},
			pay(id) {
				this.$router.push({
					path: "/orderDetails",
					query: {
						id: id,
						operate: 'pay'
					}
				});
			},



			exportOrder() {
				let times = ''
				if (this.form.times.length == 2) {
					times = `${this.form.times[0]} 00:00:00,${this.form.times[1]} 23:59:59`
				}
				this.$confirm('导出订单信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get('/api/order/index', {
						responseType: 'blob',
						params: {
							page: this.currentPage,
							limit: this.pageSize,
							status: this.status,
							warehouse_id: this.form.warehouse_id,
							pay_type: this.form.pay_type,
							is_new: this.form.is_new,
							is_sign: this.form.is_sign,
							order_number: this.form.order_number,
							other_order_number: this.form.other_order_number,
							logistics_number: this.form.logistics_number,
							source_string: this.form.source_string,
							user_shop_string: this.form.user_shop_string,
							name: this.form.name,
							times: times,
							search: this.keyword,
							export: 1

						}
					}).then(res => {
						// let url = URL.createObjectURL(res);

						// 创建一个临时的 <a> 元素用于下载
						const url = window.URL.createObjectURL(new Blob([res]));
						const link = document.createElement('a');
						link.href = url;
						let filename = `售后订单导出${new Date().getTime()}.xlsx`;
						link.setAttribute('download', filename);
						document.body.appendChild(link);
						link.click();
						link.remove(); // 下载完成后移除
						window.URL.revokeObjectURL(url); // 释放内存
						console.log(url)
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			getlist() {
				let times = ''
				if (this.form.times.length == 2) {
					times = `${this.form.times[0]} 00:00:00,${this.form.times[1]} 23:59:59`
				}
				this.$http.get('/api/order/index', {
					params: {
						page: this.currentPage,
						limit: this.pageSize,
						status: this.status,
						warehouse_id: this.form.warehouse_id,
						pay_type: this.form.pay_type,
						is_new: this.form.is_new,
						is_sign: this.form.is_sign,
						order_number: this.form.order_number,
						other_order_number: this.form.other_order_number,
						logistics_number: this.form.logistics_number,
						source_string: this.form.source_string,
						user_shop_string: this.form.user_shop_string,
						name: this.form.name,
						times: times,
						search: this.keyword,
						export: 0

					}
				}).then(res => {
					this.list = res.data.data
					this.total = res.data.total
				});

			},
		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.table-form {

		td {
			width: 33.33%;

			.el-form-item {
				margin-bottom: 0 !important;
			}
		}
	}

	.order-list {
		background-color: #fff;
		padding: 20px;
		margin-top: 20px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
		border-radius: 10px;

		.hwk-order-list {
			margin-top: 20px;
			width: 100%;

			.item {
				margin-bottom: 20px;

				.i-top {
					width: 100%;
					line-height: 40px;
					height: 40px;
					background: #F0F2FA;
					border-radius: 6px;
					align-items: center;
					justify-content: space-between;
					padding: 0 10px;
					box-sizing: border-box;

					.i {
						text-align: left;
						font-size: 14px;
						color: @color1;
					}

					.i1 {
						width: 40px;
						text-align: center;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 16px;
							height: 16px;
						}
					}

					.i2 {
						width: 100px;
						text-align: center;
					}

					.i3 {
						flex: 1;
						width: 1px;
						cursor: pointer;

						span {
							color: #3572F5;
							margin-left: 10px;
							font-size: 14px;
						}

						i {
							color: #3572F5;

						}
					}

					.i4 {
						width: 80px;
						color: @color1;
						font-size: 14px;
					}

					.on {
						color: @color2;
					}

				}

				.i-middle {
					align-items: flex-start;

					.i1 {

						flex: 1;
						width: 1px;

						.ii {
							padding: 10px 0;
							align-items: flex-start;
						}

						.iil {
							flex: 1;
							width: 1px;

							img {
								width: 50px;
								height: 50px;
								background: #FFFFFF;
								border-radius: 6px 6px 6px 6px;
								border: 1px solid #D8D8D8;
								overflow: hidden;
							}

							.con {
								flex: 1;
								width: 1px;
								margin-left: 10px;

								.name {

									font-weight: 500;
									font-size: 14px;
									color: @color1;
									line-height: 20px;
									text-align: left;

								}

								.p {
									font-size: 12px;
									color: #50607A;
									line-height: 20px;
									text-align: left;
								}
							}
						}

						.iir {
							width: 100px;

							p {
								font-size: 14px;
								color: @color1;
								text-align: left;
								line-height: 20px;
							}
						}
					}

					.i2 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;
						}
					}

					.i3 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;

							span {
								color: #868E99;
								font-size: 12px;
							}
						}
					}

					.i4 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;
						color: @color1;

						p {
							line-height: 20px;
						}
					}

					.i5 {
						box-sizing: border-box;
						padding: 10px;
						width: 100px;
						font-size: 14px;


						p {
							line-height: 30px;
							text-align: left;
							cursor: pointer;
							color: @color2;

							span {
								color: #868E99;
								margin-right: 10px;
							}
						}
					}

				}



				.i-bottom {
					padding-left: 50px;
					position: relative;

					p {
						text-align: left;
						padding: 5px;
						color: #768098;
						font-size: 14px;
						border-radius: 6px;
						background-color: #F5F7FD;
						text-indent: 10px;

						span {
							margin-right: 30px;
						}
					}

					.sh {
						align-items: center;
						justify-content: flex-end;
						position: absolute;
						right: 10px;
						bottom: 5px;

						img {
							width: 16px;
							height: 16px;
							margin-right: 5px;
						}

						span {
							font-size: 12px;
							color: #FF1717;
						}
					}
				}

				.i-bottom2 {
					padding-left: 50px;
					margin-top: 10px;

					.con {

						display: flex;
						align-items: flex-start;
						justify-content: space-between;
						width: 100%;
						padding: 5px;
						box-sizing: border-box;
						background: #FFF5EE;
						border-radius: 6px;
					}

					img {
						width: 20px;
						height: 20px;
					}

					span {
						flex: 1;
						width: 1px;
						margin-left: 10px;
						font-size: 14px;
						color: #868E99;

					}
				}
			}

			.t {
				height: 40px;
				line-height: 40px;
				background: #F7F9FA;
				border-radius: 6px;
				width: 100%;
				margin-bottom: 10px;


				.i {
					font-size: 14px;
					color: @color1;


				}

				.i1 {
					width: 60px;
					text-align: left;
					padding-left: 23px;
					box-sizing: border-box;
					display: flex;
					align-items: center;

					img {
						width: 16px;
						height: 16px;
					}
				}

				.i2 {
					flex: 1;
					width: 1px;
				}

				.i3 {
					width: 100px;
				}





			}

		}

		.o-l-r {
			flex: 1;
			width: 1px;
			margin-left: 20px;

			.search {
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-top: 20px;

				.sl {

					font-size: 14px;
					color: @color1;
					text-align: left;

					span {
						color: @color2;
						padding: 0 5px;
					}
				}

				.sr {
					flex: 1;
					width: 1px;
					display: flex;
					align-items: center;
					justify-content: flex-end;

					.s1 {
						width: 353px;
					}

					.s2 {
						margin-left: 20px;
						width: 100px;
						height: 34px;
						line-height: 34px;
						background: #FFFFFF;
						border-radius: 20px;
						border: 1px solid #D9D9D9;
						display: flex;
						align-items: center;
						justify-content: center;

						img {
							width: 16px;
							height: 16px;
							margin-right: 5px;
						}

						span {
							color: #868E99;
							font-size: 14px;
						}
					}
				}
			}

			.filter {
				margin-top: 20px;
				border-bottom: 1px solid #eee;
			}

			.top-nav {
				display: flex;
				align-items: center;
				justify-content: center;
				text-align: center;
				border-bottom: 1px solid #eee;

				.item {
					height: 40px;
					line-height: 40px;
					font-size: 16px;
					color: @color1;
					flex: 1;
					cursor: pointer;
				}

				.on {
					color: @color2;
					position: relative;

					&::after {
						content: "";
						position: absolute;
						width: 56px;
						height: 3px;
						background: @color2;
						border-radius: 6px 6px 6px 6px;
						bottom: 0;
						left: 50%;
						margin-left: -28px;
					}
				}
			}
		}


	}

	.pagination {
		padding: 20px 0;
	}

	.footer-btn {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-align: center;

		.btn1 {
			width: 100px;
			height: 34px;
			background: #FFFFFF;
			border-radius: 20px 20px 20px 20px;
			border: 1px solid #D9D9D9;
			color: #868E99;
			font-size: 14px;
			line-height: 34px;
		}

		.btn2 {
			width: 100px;
			height: 34px;
			line-height: 34px;
			background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
			border-radius: 30px 30px 30px 30px;
			color: #fff;
			font-size: 14px;
			margin-left: 20px;
		}
	}
</style>